import { useQuery } from '@tanstack/react-query'

import { getAddress } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

import { UseFetchAddress } from './type'

export const useFetchAddress = ({ params, enabled }: UseFetchAddress) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: enabled && !!params.zipcode,
    queryFn: () => getAddress(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_ADDRESS, params],
  })
}
